import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from '~pages/ranking-list/RankingListComponents.styles';
import { useActiveGameSelector } from '~slices/games';
import { useIsDesktop } from '~hooks';
import { isBetCheckProject } from '~utils/constants/betCheckConstants';
var RankingListTabs = lazy(function () {
    return import('~pages/ranking-list/RankingListTabs').then(function (module) { return ({
        default: module.RankingListTabs,
    }); });
});
var RankingListTabsGroup = lazy(function () {
    return import('~pages/ranking-list/RankingListTabsGroup').then(function (module) { return ({
        default: module.RankingListTabsGroup,
    }); });
});
var RankingList = function () {
    var t = useTranslation('tip-game').t;
    var activeGame = useActiveGameSelector();
    var isDesktop = useIsDesktop();
    var classes = useStyles();
    if (isBetCheckProject)
        return null;
    var rankingList = (activeGame === null || activeGame === void 0 ? void 0 : activeGame.groupKey) ? (React.createElement(RankingListTabsGroup, null)) : (React.createElement(RankingListTabs, null));
    if (isDesktop) {
        return (React.createElement("div", { className: classes.desktopWrapper },
            React.createElement("div", { className: classes.title }, t('ranking-list.ranking-list')),
            rankingList));
    }
    return rankingList;
};
export default RankingList;
